var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.logList,
            border: true,
            "max-height": "400px",
            size: "small",
            "tooltip-effect": "dark",
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "操作时间", width: "150" },
          }),
          _c("el-table-column", {
            attrs: { prop: "operator", label: "操作方", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.operator || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "operatorUser", label: "操作人", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.operator === "系统管理员-后台"
                      ? _c("yd-link", {
                          attrs: {
                            value: scope.row.operatorUser,
                            type: "systemUser",
                            query: { userId: scope.row.unionUserId },
                          },
                        })
                      : scope.row.operator === "用户"
                      ? _c("yd-link", {
                          attrs: {
                            permi: "user_center_manage",
                            value: scope.row.operatorUser,
                            url:
                              "/customer/user/index/" +
                              scope.row.operatorUser +
                              "/" +
                              scope.row.unionUserId,
                            type: "userInfo",
                            need: true,
                          },
                        })
                      : _c("span", [_vm._v(_vm._s(scope.row.operatorUser))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "operateType", label: "操作类型", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.operateType || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "operateContent", label: "操作内容" },
          }),
          _c("el-table-column", {
            attrs: { prop: "sourceOperateContent", label: "原内容" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }